/**
 * The badges a delivery row wears, shared by the fleet-wide list and the
 * task's own timeline so the two never disagree on a color.
 */
import type { DeliveryEvent, DeliveryStatus } from '@optum/api-client/types';

import { Badge } from '../../ui/finixt.js';

const STATUS_TONE: Record<DeliveryStatus, 'ok' | 'warn' | 'danger'> = {
  delivered: 'ok',
  pending: 'warn',
  failed: 'danger',
};

/** Where the delivery stands: pending, delivered, or failed. */
export function DeliveryStatusBadge({ status }: { status: DeliveryStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{status}</Badge>;
}

/** Which event the row announces, in the name the receiver sees. */
export function EventBadge({ event }: { event: DeliveryEvent }) {
  return <Badge tone="neutral">{event}</Badge>;
}

/** The task status the row announced, or a dash on a row that predates snapshots. */
export function AnnouncedStatus({ value }: { value: string | null }) {
  if (value === null)
    return <span style={{ fontSize: 'var(--text-meta-lg)', color: 'var(--text-muted)' }}>—</span>;
  return <Badge tone="neutral">{value}</Badge>;
}
